import { SheqManagerList } from "./components/SheqManagerList";

export default SheqManagerList;